import { isProduction as m } from "./Environment.js";
const k = m() ? { authID: "TBD", authToken: "TBD", hostUrl: "https://use.typekit.net/", kitId: "TBD" } : { authID: "tk", authToken: "yVuu9k+JlRHjrLOYIHApqThcZx4kDa9x42lMaC8J9bPL6rmAdBHLO0EIkrBMbL4FDWJrG7ThjPr401kso4XcBEreSK6Bb/S1nf70D1lYdgg=", hostUrl: "https://use-staging.typekit.net/", kitId: "klx1orp" }, d = "wf-loading";
function u() {
  return window.Typekit;
}
let c;
async function g(t) {
  const e = u();
  return e ? Promise.resolve(e) : (c = new Promise((n, o) => {
    const s = document.documentElement;
    s.classList.add(d);
    const l = setTimeout(() => {
      s.classList.remove(d), s.classList.add("wf-inactive"), console.log("Timed out while waiting to load Typekit"), o();
    }, 3e3), a = document.createElement("script");
    a.src = `${k.hostUrl}/${t.kitId}.js`, a.async = !0, a.addEventListener("load", () => {
      clearTimeout(l);
      const i = window.Typekit;
      i.user = t.authID, i.token = t.authToken, n(i);
    });
    const r = document.getElementsByTagName("script")[0];
    r != null && r.parentNode && r.parentNode.insertBefore(a, r);
  }), c);
}
async function h(t, e, n = {}) {
  n.unicodeRange || (n.unicodeRange = "U+0000-007F");
  try {
    await c;
  } catch {
    return Promise.reject();
  }
  const o = u();
  return o && o.Font ? new o.Font(t, e, n).load().then((s) => {
    o.fonts.add(s);
  }) : Promise.reject();
}
function T() {
  var t;
  return (t = u()) == null ? void 0 : t.fonts;
}
function f(t) {
  return [...new Set(Array.from(t))].map((e) => {
    var n;
    return "U+" + ((n = e == null ? void 0 : e.codePointAt(0)) == null ? void 0 : n.toString(16));
  }).sort().join(",");
}
function w(t, e) {
  return t.update(e);
}
export {
  u as getAPI,
  T as getFontsOnPage,
  f as getUnicodeFromText,
  h as loadFont,
  g as loadKit,
  w as updateFont
};
//# sourceMappingURL=DynamicKit.js.map
